import React from 'react';
import { FormInputFieldsFragment } from 'types/generated';
import TextInputOld from 'components/src/textInput';
import { getOr } from '@/utils/options';
import DropDown from 'components/src/dropdown';
import Checkbox from 'components/src/checkbox';
import Button from 'components/src/button';
import { usePackageSuggestionContext } from './PackageSuggestionContext';
import { useIsMedium } from '@/utils/hooks';

type FormInputProps = {
  data: Array<FormInputFieldsFragment>;
  buttonText: string;
  canContinue: boolean;
  onNextClick: () => void;
};

const InputForms = ({ data, buttonText, canContinue, onNextClick }: FormInputProps) => {
  const { state, dispatch } = usePackageSuggestionContext();
  const inputForms = state.inputForms;
  const watchList = state.watchList;
  const isMedium = useIsMedium();

  return (
    <>
      <div className="grid grid-cols-1 gap-x-16 gap-y-8 sm:grid-cols-3 ">
        {data.map((form) => {
          if (!(form.title && form.id)) return null;
          else if (form.inputType === 'dropdown') {
            const options = form.values?.reduce<Array<{ value: string; label: string }>>((acc, value) => {
              value && acc.push({ value: value, label: value });
              return acc;
            }, []);

            const selectedValue = inputForms[form.id]
              ? { value: inputForms[form.id], label: inputForms[form.id] }
              : null;

            return (
              <div key={form.id} className={'col-span-full max-w-[264px] md:col-span-1'}>
                <DropDown
                  key={form.id}
                  id={form.id}
                  label={form.title}
                  placeholder={getOr(form.placeholder, '')}
                  options={getOr(options, [])}
                  onChange={(value) => {
                    if (value?.label && form.id) {
                      dispatch({ type: 'UPDATE_INPUT_FORMS', payload: { id: form.id, value: value.label } });
                    }
                  }}
                  selectedOption={selectedValue}
                  isSearchable={isMedium}
                />
              </div>
            );
          } else if (form.inputType === 'checkbox') {
            return (
              <Checkbox
                key={form.id}
                label={form.title}
                id={form.id}
                onChange={(value) => {
                  dispatch({
                    type: 'UPDATE_WATCHLIST',
                    payload: { id: value.target.id, checked: value.target.checked },
                  });
                }}
                checked={watchList[form.id]}
                large
              />
            );
          }
          return (
            <div key={form.id} className="col-span-2">
              <TextInputOld
                key={form.id}
                label={form.title}
                id={form.id}
                placeholder={getOr(form.placeholder, '')}
                type={getOr(form.inputType, 'text')}
                onChange={(value) => {
                  if (form.id) {
                    dispatch({ type: 'UPDATE_INPUT_FORMS', payload: { id: form.id, value } });
                  }
                }}
                value={inputForms[form.id] || ''}
              />
            </div>
          );
        })}
      </div>
      <Button
        label={buttonText}
        variant={'primary'}
        classes="mt-56 w-full lg:w-auto"
        onClick={onNextClick}
        disabled={!canContinue}
      />
    </>
  );
};
export default InputForms;
